var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleClipHeaderEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 13,
    viewBox: "0 0 24 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0242 6.65471C23.6382 6.94207 24.2818 6.30608 23.8698 5.77508C21.1466 2.26547 16.843 0 11.9999 0C7.15699 0 2.85339 2.2654 0.130208 5.77492C-0.281813 6.30592 0.361833 6.94191 0.975791 6.65456C2.5969 5.89585 4.39896 5.29989 6.32967 4.90188C6.06909 5.566 5.92624 6.28747 5.92624 7.04167C5.92624 10.3324 8.64552 13 11.9999 13C15.3543 13 18.0736 10.3324 18.0736 7.04167C18.0736 6.28749 17.9308 5.56603 17.6702 4.90192C19.601 5.29996 21.4031 5.89595 23.0242 6.65471ZM15.865 7.04167C15.865 9.13575 14.1345 10.8333 11.9999 10.8333C9.86531 10.8333 8.13486 9.13575 8.13486 7.04167C8.13486 4.94759 9.86531 3.25 11.9999 3.25C14.1345 3.25 15.865 4.94759 15.865 7.04167Z",
    fill: "#A79FBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleClipHeaderEye);
export default __webpack_public_path__ + "static/media/singleClipHeaderEye.0f3c2ab32d220e295ed24b8370366025.svg";
export { ForwardRef as ReactComponent };